import React from 'react';
import { Box, Flex, Heading, Text } from '@qga/roo-ui/components';

import StarRating from '@shared/v2/components/StarRating';
import getSuburbName from '@shared/v2/utils/getSuburbName';

import HolidaysIcon from '@/shared/components/HolidaysIcon';
import HeaderCta from '@/v2/components/pages/PackageView/components/PackageHeader/HeaderCta';
import PropertyTags from '@/v2/components/pages/PackageView/components/PropertyTags/PropertyTags';
import { UI } from '@/v2/types';

interface Props {
  main?: boolean;
  propertyContent: UI.Property;
}

const PackageHeader = React.memo(({ propertyContent }: Props) => {
  const destinationName = propertyContent.destination?.title;
  const { name, rating, ratingType, suburb } = propertyContent;
  const { tags } = propertyContent;

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={['column', null, 'row']}
    >
      <Box>
        <Flex mb="1" gap="2">
          <HolidaysIcon />
          <Text fontSize="14px" fontWeight={600}>
            {getSuburbName(suburb, destinationName)}
          </Text>
        </Flex>
        <Heading.h2 fontSize={'28px'} fontWeight={400}>
          {name}
        </Heading.h2>
        <Flex
          flexDirection={['column', null, 'row']}
          justifyContent="start"
          alignItems={[null, null, 'center']}
          pt={[0, null, 2]}
        >
          <Box>
            <StarRating rating={rating} ratingType={ratingType} size={16} />
          </Box>
          {tags && (
            <Box ml={[null, null, 2]} pt={[2, null, 0]}>
              <PropertyTags tags={tags} />
            </Box>
          )}
        </Flex>
      </Box>
      <HeaderCta />
    </Flex>
  );
});

export default PackageHeader;
